module.exports = __webpack_public_path__ + "images/emoji/four_leaf_clover.44fc76e37de5c71f1ff0.png";